// extracted by mini-css-extract-plugin
export default {"aboutUs":"About_aboutUs__OoowE","aboutText":"About_aboutText__vHqoz"};